export const formatNotificationsCount = value => (value > 99 ? "99+" : value);
